<template>
    <Drawer class="min-drawer" v-model="openDrawer" title="司机进程" width="400px">
        <Timeline>
            <TimelineItem v-for="(item, index) in markList" :key="index" :item="item">
                <Icon v-if="false" slot="dot" style="font-size: 20px;" type="md-checkmark-circle" />
                <h4 style="font-size: 18px;font-weight: bold;margin-bottom: 20px;">
                    {{ item.nodeName }} <Tag color="red">{{ item.creator }}</Tag>
                    <a @click="add(item)" style="float: right;font-size: 14px;
                    font-weight: lighter;" v-show="item.isPerson == 1">回到该节点</a>

                </h4>
                <ly-form-item label="定位时间">
                    {{ utils.time(item.ex_time) }}
                </ly-form-item>
                <ly-form-item label="定位地址">
                    {{ item.ex_address }}
                </ly-form-item>
                <ly-form-item label="定位里程">
                    {{ item.ex_mileage }}
                </ly-form-item>
                <filePathList :data="item"></filePathList>
                <event :data="item"></event>
                {{ item.content }}

            </TimelineItem>
        </Timeline>

    </Drawer>
</template>
<script>

import event from "./event.vue";
import filePathList from "./filePathList.vue"
export default {
    components: { event, filePathList },
    data() {
        return {
            item: {
                flowId: "",
                //pageNumber: 0,
                //pageSize: 0,
                docNo: "",
                driverAccount: "",
                nodeId: ""
            },
            markList: [],
            openDrawer: false
        }
    },
    methods: {
        open(v) {
            this.markList = [];
            this.item.flowId = v.flowId;
            this.item.docNo = v.ono;
            this.nodeId=v.nodeId;
            
            this.openDrawer = true;
            this.getList();
        },
        getList() {
            this.utils.loading(this, "加载中");
            this.axios({
                method: "post",
                //url: this.axios.ipPort + "/cloud-ofc-server-web/app/dispatch/nodeList",
                url: this.axios.ipPort + "/cloud-ofc-server-web/flow/nodeList",
                data: this.item,
            }).then((res) => {
                this.$Spin.hide(); //关闭加载
                this.total = res.data.data.total;
                var data = res.data.data;
                for (let i = 0; i < data.length; i++) {
                    data[i].createTime1 = this.utils.time(data[i].createTime);
                    data[i].startTime1 = this.utils.time(data[i].startTime);
                    data[i].endTime1 = this.utils.time(data[i].endTime);
                    this.stringTo(data[i]);
                }
                this.markList = data;
                console.log('历史进程', data);
                //this.back();
            });
        },
        getInfo(a, k) {
            this.utils.loading(this, "加载中");
            this.axios({
                method: "post",
                url: this.axios.ipPort + "/cloud-tmsa-server-web/orders/info",
                data: { no: a.docNo }
            }).then((res) => {
                this.$Spin.hide(); //关闭加载
                var data = res.data.data;
                //console.log('xiangqing',data);
                this.$refs[k].open(a, data);
            });
        },
        back(){
            var data=this.markList;
            let index=0;
            
            for (let i = 0; i < data.length; i++) {
                if (this.nodeId==data[i].nodeId) {
                    index=i;
                    
                    break
                }
                
            }
            if (index<=this.markList.length-1) {
                console.log(this.markList);
                this.add(this.markList[index+1]);
            }
        },
        add(a) {
            
            this.$emit('toNode', a);
            this.openDrawer = false;
            return;
            //this.openDrawer=false;
            var rule = {
                发车: 'fache',
                装货: 'zhuanghuo',
                口岸: 'jiaoche',
                卸货: 'xiehuo',
            }
            if (a.rule == '口岸') {
                this.$Message.info('交接车暂不支持')
                return;
            }
            this.getInfo(a, rule[a.rule]);
            // this.$Message.info('开发中')
        },
        stringTo(data) {
            var extend=data.extend;
            var obj = {
                "mileage": 0,
                "time": 0,
                "address": "",
                "x": 0,
                "y": 0
            };
            if (!this.utils.isEmpty(extend)) {

                obj = JSON.parse(extend);
                
                
                
            }
            for (const i in obj) {
                data['ex_'+i]=obj[i];
            }
            

        }

    }

}
</script>


// WEBPACK FOOTER //
// src/components/diaodu/jincheng/jincheng.vue